var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeanutTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.86,172.79c-11.42,0-22.22-3.5-29.11-10A41.1,41.1,0,0,1,40.26,126.1c2.27-12.79,10.85-23.22,23.53-28.61C75.94,92.34,84.37,87.8,90.6,72.31c6.06-15.06,17.31-25.19,31.69-28.52A47.22,47.22,0,0,1,164.4,55.13h0a33,33,0,0,1,10.17,31.75c-1.85,7.71-8.62,21.61-33.14,28.17-10.33,2.76-15.08,19-17.75,31.05-2.48,11.19-11.76,20-25.44,24.24A55.93,55.93,0,0,1,81.86,172.79ZM132.42,48.15a39.27,39.27,0,0,0-8.88,1C111,52.08,101.08,61,95.72,74.37,88.16,93.14,76.36,98.15,66,102.57c-11.09,4.71-18.29,13.41-20.26,24.5a35.51,35.51,0,0,0,10.83,31.72c8.81,8.27,25.29,10.85,40.09,6.28,11.74-3.62,19.64-11,21.69-20.16,3-13.41,8.47-31.65,21.71-35.19,16.12-4.31,26.49-12.88,29.19-24.13a27.39,27.39,0,0,0-8.49-26.36A42.45,42.45,0,0,0,132.42,48.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.23,71.5a3,3,0,0,1-1.15-.24,2.77,2.77,0,0,1-1.36-3.66C113.23,59.92,122,56.48,127,56a2.76,2.76,0,0,1,.48,5.5c-2.41.21-9.93,2.19-12.74,8.35A2.74,2.74,0,0,1,112.23,71.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.7,83.76a2.76,2.76,0,0,1-.2-5.51c3.19-.23,8.41-4,10.16-7.4a2.76,2.76,0,1,1,4.89,2.54c-2.67,5.15-9.52,10-14.66,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.61,155.41a12.28,12.28,0,0,1-3.19-.39,2.76,2.76,0,0,1,1.44-5.32c3.08.83,9.27-1,12-3.65a2.76,2.76,0,1,1,3.79,4A22.35,22.35,0,0,1,83.61,155.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.76,71.5a2.75,2.75,0,0,1-1.47-5.09c3.18-2,5.68-7.85,6.08-11.17a2.76,2.76,0,0,1,5.48.66c-.53,4.38-3.55,12-8.62,15.18A2.74,2.74,0,0,1,132.76,71.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeanutTag);
export default __webpack_public_path__ + "static/media/PeanutTag.ea51d1a6c8065c42e5c106e30d3eac6b.svg";
export { ForwardRef as ReactComponent };